<template>
  <div>
    <el-card class="box-card">
      <el-row :gutter="0" style="margin-bottom: 10px">
        <el-col :span="4">
          <el-button type="primary" @click="addHostVisable = true"
            >添加数据来源</el-button
          >
        </el-col>
      </el-row>
      <el-table :data="tableList" border stripe>
        <el-table-column label="id" prop="id"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="warning" @click="del(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加系列的弹出框 -->
      <el-dialog title="提示" :visible.sync="addHostVisable" width="50%">
        <el-form
          :model="addHostForm"
          :rules="rules"
          ref="addHostFormRef"
          label-width="100px"
        >
          <el-form-item label="系列名称" prop="name">
            <el-input v-model="addHostForm.name"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addHostVisable = false">取 消</el-button>
          <el-button type="primary" @click="addHost">提 交</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "AdminHost",
  data() {
    return {
      hostList: [],
      pagenum: 1,
      pagesize: 2,
      total: 0,
      tableList: [],
      addHostVisable: false,
      addForm: {},
      addHostForm: {},
      formRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在2到30之间", trigger: "blur" },
        ],
        nickname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      //发起请求
      request.get("/common/getCopperHostList", {}).then((res) => {
        this.tableList = res.data;
      });
    },
    addHost() {
      this.$refs.addHostFormRef.validate((valid) => {
        if (!valid) return;
        //发起网络请求
        request.post("/admin/copper/host", this.addHostForm).then((res) => {
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getTableData();
            this.addHostForm = {}
            this.addHostVisable = false;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      });
    },
    //删除
    del(id) {
      console.log(id);
      this.$confirm("是否删除该系列？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request.delete("/admin/copper/host/" + id, {}).then((res) => {
            if (res.code == "0") {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getTableData();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          console.log("取消");
        });
    },
  },
};
</script>

<style scoped>
</style>
